/**
 * Copyright (C) IRT GmbH 2020
 */

 /**
 * Function to filter material information for service type and names
 *
 * @param {boolean} debug if true adds STANDARD audio to response if no dialogplus is found
 * @param {string} target ID of a target device, e.g. "SMARTPHONE", "MULTISTREAM"
 * @param {string} svctype service type, e.g. DIALOGPLUS
 * @param {Array<string>} svcnames service names to look for
 * @param {string} svctype_alt alternative service type, if other one can't be find.
 * @param {Array<string>} svcnames_alt alternative service names
 *
 * @returns {Function} function that filters material.
 */
module.exports = function (debug, target, svctype, svcnames, svctype_alt, svcnames_alt) {

    /**
     * Extract available dialog plus streams from all companion streams.
     *
     * @param {Array<Object>} streams companion streams
     * @returns {Array<Object>} a list of available dialog plus streams or if these are not available, all availalbe
     * 					standard audio tracks.
     */
    function filterCompanionStreams(streams) {
        var dp_streams = [];
        var st_streams = [];

        for (x in streams) {
            var stream = streams[x];
            if (stream.available &&
                stream.target.indexOf(target) >= 0
                )
            {
                if (stream.serviceType == svctype &&
                    (!svcnames || svcnames.indexOf(stream.name) >= 0))
                {
                    dp_streams.push(stream);
                } else if (debug && stream.serviceType == svctype_alt &&
                    svcnames_alt.indexOf(stream.name) >= 0)
                {
                    st_streams.push(stream);
                } else {
                    // console.log("service type doesnot match");
                }
            } else {
                // console.log("availability does not match");
            }
        }
        return dp_streams.length > 0 ? dp_streams : st_streams;
    }

    return filterCompanionStreams;
};
